import apiClient from './apiClient';
import { Participant } from '../models/Participant';

export const fetchParticipantes = async (
  boxId: number,
  date: string, // YYYY-MM-DD
  time: string, // HH:mm:ss
  scheduleId: number,
): Promise<Participant[]> => {
  //const newTime = addMinutesToTime(time, 10); // un minuto antes mostrar los participantes

  ///mock
  // date = '2025-09-18';
  // const newTime = '12:30:00';

  //const url = `/wods/participants/box/${boxId}/date/${date}/time/${newTime}/schedule/${scheduleId}`;
  const url = `/wods/participants/box/${boxId}/date/now/schedule/${scheduleId}`;
  const { data } = await apiClient.get<{
    success: boolean;
    status: number;
    data: Participant[];
  }>(url, {
    params: {
      expand: 'user.profile',
    },
  });

  if (!data || !data.success) {
    throw new Error('Error al obtener participantes');
  }

  return data.data;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function addMinutesToTime(time: string, minutesToAdd: number): string {
  const [h = '0', m = '0', s = '0'] = time.split(':');
  const date = new Date();
  date.setHours(Number(h), Number(m), Number(s || '0'), 0);
  date.setMinutes(date.getMinutes() + minutesToAdd);

  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}
